import { TeamsUFOExperience } from '@atlassian/teams-client/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, untilAll } from '@atlassian/ufo';

export const renderTeamMemberRemoveDialogSubExp = new TeamsUFOExperience(
	'render-team-member-remove-dialog',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const removeMemberFromTeamSubExp = new TeamsUFOExperience('remove-member-from-team-action', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	platform: { component: 'people' },
});

const removeMemberFromTeamSubExperiences: TeamsUFOExperience[] = [
	renderTeamMemberRemoveDialogSubExp,
	removeMemberFromTeamSubExp,
];

export const removeMemberFromTeamExp = new TeamsUFOExperience('remove-a-member-from-team', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.Custom,
	platform: { component: 'people' },
	until: untilAll(
		removeMemberFromTeamSubExperiences.map((experience) => ({
			experience,
		})),
	),
});

export const teamSettingsOverallExp = new TeamsUFOExperience('membership-control-change', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	platform: { component: 'people' },
});

export const teamSettingsHandleRequestsExp = new TeamsUFOExperience(
	'membership-control-change-handle-requests',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const teamSettingsChangeTeamTypeExp = new TeamsUFOExperience(
	'membership-control-change-change-team-type',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const renderTeamMemberInviteDialogSubExp = new TeamsUFOExperience(
	'render-team-member-invite-dialog',
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: 'people' },
	},
);

export const addNewMembertoTeamSubExp = new TeamsUFOExperience('add-new-member-to-team-action', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.InlineResult,
	platform: { component: 'people' },
});

const inviteMembersToTeamSubExperiences: TeamsUFOExperience[] = [
	renderTeamMemberInviteDialogSubExp,
	addNewMembertoTeamSubExp,
];

export const inviteMembersToTeamExperience = new TeamsUFOExperience('invite-members-to-team', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.Custom,
	platform: { component: 'people' },
	until: untilAll(inviteMembersToTeamSubExperiences.map((experience) => ({ experience }))),
});
